import React from "react";

const VARIANT_CLASS = {
  page: "dashboard-page-title",
  section: "dashboard-section-title",
  widget: "dashboard-widget-title",
  panel: "dashboard-panel-title",
  label: "dashboard-label-heading",
};

/**
 * Dashboard Typography System — headings (lg / xl / 2xl via CSS tokens on `.dashboard-panel`).
 * Used in admin, business, and customer logged-in areas.
 */
const DashboardHeading = ({ variant = "section", as, children, className = "" }) => {
  const Tag = as || (variant === "page" ? "h1" : variant === "section" ? "h2" : "h3");
  const styleClass = VARIANT_CLASS[variant] || VARIANT_CLASS.section;

  return (
    <Tag className={`${styleClass} text-offblack ${className}`.trim()}>{children}</Tag>
  );
};

export default DashboardHeading;
